<div class="" cdkDropListGroup>
  <mat-tab-group
    (selectedIndexChange)="change($event)"
    class="mgTop"
    mat-align-tabs="start"
    data-tour="bandeja.estados"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        Sin asignar
        <span
          class="badgeClass"
          [matBadge]="allAlertsAbierto.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Asignado
        <span
          class="badgeClass"
          [matBadge]="allCasesAssigned.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        En proceso
        <span
          class="badgeClass"
          [matBadge]="allCasesRunning.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Por aprobar
        <span
          class="badgeClass"
          [matBadge]="allCasesTobeApproved.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        Finalizado
        <span
          class="badgeClass"
          [matBadge]="allCasesToFinalize.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        General
        <span
          class="badgeClass"
          [matBadge]="allCases.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>
    <!-- <mat-tab>
      <ng-template mat-tab-label>
        Rechazado
        <span
          class="badgeClass"
          [matBadge]="allAlertsRechazado.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab> -->
    <mat-tab>
      <ng-template mat-tab-label>
        Urgentes
        <span
          class="badgeClass"
          [matBadge]="allAlertsFinalized.length"
          matBadgeOverlap="false"
        ></span>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="bx-card">
  <!-- Esqueleto mientras carga (QA 05-10) -->
  <div class="bx-skeleton" *ngIf="loading">
    <div class="bx-skeleton__row" *ngFor="let r of [1, 2, 3, 4, 5, 6]">
      <span class="sk sk--s"></span>
      <span class="sk sk--l"></span>
      <span class="sk sk--m"></span>
      <span class="sk sk--m"></span>
      <span class="sk sk--s"></span>
    </div>
  </div>
  <table
    [hidden]="loading"
    mat-table
    data-tour="bandeja.lista"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    class="mat-elevation-z8"
  >
    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content first">
          <div class="header-child white">white</div>
        </div>
      </th>

      <td class="pointerMouse" mat-cell *matCellDef="let element">
        <div class="botOptions">
          <div>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngIf="needApproval(element)"
                (click)="approval(element)"
              >
                Aprobar caso
              </button>
              <button
                mat-menu-item
                (click)="finishCase(element)"
                *ngIf="
                  element.status == 'toFinalize' &&
                  canFinish &&
                  element.numberRas
                "
              >
                Archivar Caso
              </button>
            </mat-menu>
          </div>
          <div
            *ngIf="valueTab != 0 && valueTab != 6 && valueTab != 7"
            class="divCheckAproved"
          >
            <mat-menu #checkAproved="matMenu">
              <div
                *ngIf="element.approvalStatus == 'approved'"
                class="divCheckAproved mar"
              >
                <mat-icon class="checkAproved">check_circle</mat-icon>
                <p class="checkAproved textAproved">Aprobado</p>
              </div>
              <div
                *ngIf="
                  element?.caseType.approvalRoles?.levelTwo &&
                  element?.approvalStatus == 'requestLevelTwo'
                "
                class="divCheckAproved mar"
              >
                <mat-icon class="checkAprove">error</mat-icon>
                <p class="checkAprove textAproved">requiere aprobación ODC</p>
              </div>
              <div
                *ngIf="
                  element.caseType.approvalRoles?.levelOne &&
                  element?.approvalStatus == 'requestLevelOne'
                "
                class="divCheckAproved mar"
              >
                <mat-icon class="checkAprove">error</mat-icon>
                <p class="checkAprove textAproved">
                  requiere aprobación Gerente
                </p>
              </div>
            </mat-menu>
            <mat-icon
              *ngIf="element.approvalStatus != 'undefined'"
              [matMenuTriggerFor]="checkAproved"
              [matTooltip]="
                element.approvalStatus == 'approved'
                  ? 'Caso Aprobado '
                  : 'No Aprobado'
              "
              [ngClass]="
                element.approvalStatus == 'approved'
                  ? 'checkAproved'
                  : 'checkAprovedNot'
              "
              class="pointer"
              >check_circle</mat-icon
            >
            <mat-icon
              [matTooltip]="'No Aprobado'"
              class="checkAprovedNot"
              *ngIf="element.approvalStatus == 'undefined'"
              >check_circle</mat-icon
            >
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="gai">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content">
          <div class="header-child">Número</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        *matCellDef="let element"
      >
        {{ element.gai }}
      </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content">
          <div class="header-child">Descripción</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        *matCellDef="let element"
      >
        {{ element.description }}
      </td>
    </ng-container>
    <ng-container matColumnDef="caseType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content">
          <div class="header-child">Tipo de caso</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        *matCellDef="let element"
      >
        Análisis de fraude
      </td>
    </ng-container>
    <ng-container matColumnDef="creator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content">
          <div class="header-child">
            <ng-container>{{
              valueTab == 0 ? "Creado por" : "Asignado a"
            }}</ng-container>
          </div>
        </div>
      </th>
      <td
        class="pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        mat-cell
        *matCellDef="let element"
      >
        <ng-container *ngIf="element.assigned">
          {{ element.assigned.fullname }}
        </ng-container>
        <ng-container *ngIf="!element.assigned">
          {{ element.creator.fullname }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content last">
          <div class="header-child">Fecha de Creación</div>
        </div>
      </th>
      <td
        class="mat-column-last pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        mat-cell
        *matCellDef="let element"
      >
        <span *ngIf="element.alert?.createdAt; else showElementCreatedAt">
          {{ element.alert.createdAt | date : "d/M/yy hh:mm" }}
        </span>
        <ng-template #showElementCreatedAt>
          {{ element.createdAt | date : "d/M/yy hh:mm" }}
        </ng-template>
      </td>
    </ng-container>
    <ng-container *ngIf="valueTab != 7" matColumnDef="datePast">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-content last">
          <div class="header-child">Días transcurridos</div>
        </div>
      </th>
      <td
        class="mat-column-last pointerMouse"
        (click)="seeCase(element, element.status, element.a, element.b)"
        mat-cell
        *matCellDef="let element"
      >
        <span class="bx-days" [ngClass]="diasClase(datePast(element))">{{
          datePast(element)
        }}</span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div class="bx-empty" *ngIf="!loading && !dataSource?.data?.length">
    <mat-icon>inbox</mat-icon>
    <span>No hay {{ valueTab == 6 ? 'alertas urgentes' : 'elementos' }} en esta pestaña con los filtros actuales.</span>
  </div>
  <mat-paginator
    class="paginator"
    [pageSizeOptions]="[10, 25, 50, 100]"
    showFirstLastButtons
    aria-label="Paginación"
  ></mat-paginator>
  </div>
</div>
